import React, { Component } from 'react'
import { DateCalendarContainer } from '../../Commons/DateCalendar'
import { withTranslation } from 'react-i18next'
import PropTypes from "prop-types";

class EventDate extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div>
                { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.nominative_with_date.steps.event_date.title') }
                <DateCalendarContainer hasFocus={true} fieldName={"eventDate"} />
            </div>
        )
    }
}

export default withTranslation()(EventDate)
